import { render, staticRenderFns } from "./Cola2.vue?vue&type=template&id=453f7020"
import script from "./Cola2.vue?vue&type=script&lang=js"
export * from "./Cola2.vue?vue&type=script&lang=js"
import style0 from "./Cola2.vue?vue&type=style&index=0&id=453f7020&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports